import { upperFirst } from 'lodash';

const populateFormFields = ({ setValue, selectedRuleset }) => {
  if (!selectedRuleset) return;

  // Format HH:MM:SS to { value: "HH:MM", label: "HH:MM" }
  const formatTimeForForm = (timeString) => {
    if (!timeString) return null;
    const time = timeString?.substring(0, 5);
    return { value: time, label: time };
  };

  const brandValue = selectedRuleset?.brandName ? { label: selectedRuleset?.brandName, value: selectedRuleset?.brandName } : null;
  setValue('brand', brandValue, { shouldDirty: false });

  const typeValue = selectedRuleset?.type ? { label: selectedRuleset?.type, value: selectedRuleset?.type } : null;
  setValue('type', typeValue, { shouldDirty: false });

  setValue('normalLiveHours', selectedRuleset?.liveHours ? { label: `${selectedRuleset?.liveHours} Jam/Hari`, value: `${selectedRuleset?.liveHours}` } : '1', {
    shouldDirty: false,
  });
  setValue(
    'paydayLiveHours',
    selectedRuleset?.paydayLiveHours ? { label: `${selectedRuleset?.paydayLiveHours} Jam/Hari`, value: `${selectedRuleset?.paydayLiveHours}` } : '1',
    { shouldDirty: false }
  );

  setValue('normalStart', formatTimeForForm(selectedRuleset?.normalStart), { shouldDirty: false });
  setValue('normalEnd', formatTimeForForm(selectedRuleset?.normalEnd), { shouldDirty: false });
  setValue('paydayStart', formatTimeForForm(selectedRuleset?.paydayStart), { shouldDirty: false });
  setValue('paydayEnd', formatTimeForForm(selectedRuleset?.paydayEnd), { shouldDirty: false });

  setValue('isUseAgency', selectedRuleset?.isUseAgency || false, { shouldDirty: false });
  setValue('agencyNormalStart', formatTimeForForm(selectedRuleset?.agencyNormalStart), { shouldDirty: false });
  setValue('agencyNormalEnd', formatTimeForForm(selectedRuleset?.agencyNormalEnd), { shouldDirty: false });
  setValue('agencyPaydayStart', formatTimeForForm(selectedRuleset?.agencyPaydayStart), { shouldDirty: false });
  setValue('agencyPaydayEnd', formatTimeForForm(selectedRuleset?.agencyPaydayEnd), { shouldDirty: false });

  // Transform accountLivestreams to accountId/studio based on type
  if (selectedRuleset?.accountLivestreams && selectedRuleset?.accountLivestreams?.length > 0) {
    const type = selectedRuleset?.type;

    if (type === 'Mirroring') {
      const accountIds = selectedRuleset?.accountLivestreams?.map((acc) => ({
        value: acc?.id,
        label: `<strong>${upperFirst(acc?.name)}</strong> ${acc?.ecommerce}`,
      }));
      setValue('accountId', accountIds, { shouldDirty: false });

      const studio = selectedRuleset?.accountLivestreams?.[0];
      setValue('studio', { value: studio?.studioId, label: `${studio?.roomName} - ${studio?.studio}` }, { shouldDirty: false });
    } else if (type === 'Dedicated') {
      const account = selectedRuleset?.accountLivestreams?.[0];
      setValue('accountId', { value: account?.id, label: `<strong>${upperFirst(account?.name)}</strong> ${account?.ecommerce}` }, { shouldDirty: false });
      setValue('studio', { value: account?.studioId, label: `${account?.roomName} - ${account?.studio}` }, { shouldDirty: false });
    } else if (type === 'Cross-Platform') {
      const [first, second] = selectedRuleset?.accountLivestreams;
      setValue('accountId', { value: first?.id, label: `<strong>${upperFirst(first?.name)}</strong> ${first?.ecommerce}` }, { shouldDirty: false });
      setValue('studio', { value: first?.studioId, label: `${first?.roomName} - ${first?.studio}` }, { shouldDirty: false });
      setValue('accountId2', { value: second?.id, label: `<strong>${upperFirst(second?.name)}</strong> ${second?.ecommerce}` }, { shouldDirty: false });
      setValue('studio2', { value: second?.studioId, label: `${second?.roomName} - ${second?.studio}` }, { shouldDirty: false });
    }
  }

  // Transform users to selectedHost
  if (selectedRuleset?.users && selectedRuleset?.users?.length > 0) {
    const selectedHosts = selectedRuleset?.users?.map((user) => ({
      value: user?.id,
      label: user?.name,
      isPregnancy: user?.isPregnancy,
    }));
    setValue('selectedHost', selectedHosts, { shouldDirty: false });
  }

  setValue('host', null, { shouldDirty: false });
};

export default populateFormFields;
